import { render, staticRenderFns } from "./TableDetail.vue?vue&type=template&id=8d09c40e&scoped=true&"
import script from "./TableDetail.vue?vue&type=script&lang=js&"
export * from "./TableDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableDetail.vue?vue&type=style&index=0&id=8d09c40e&prod&scoped=true&lang=css&"
import style1 from "./TableDetail.vue?vue&type=style&index=1&id=8d09c40e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09c40e",
  null
  
)

export default component.exports